// Modules
import { FieldArray, Field } from 'redux-form';
import PropTypes from 'prop-types';
import React from 'react';

import { PHONE_TYPES } from 'constants';
import { RemoveButton } from 'components/widgets/buttons';
import { Row, Subform, SubformHeader } from 'components/forms/form-structure';
import { TextInput, SelectInput } from 'components/forms/form-elements';
import { convertArrayToOptions } from 'utils/input-utils';
import { preventDefault } from 'utils/event-handlers';

function RenderNumbers({ fields, meta }) {
  return (
    <Subform>
      <SubformHeader>
        Phone Numbers
        { meta.error && meta.error !== ' ' && <div className="invalid-alert">{meta.error}</div> }
      </SubformHeader>
      <div className="phone-number-input-list">
        { fields.map((name, index) =>
          <Row key={index}>
            <Field component={TextInput} name={`${name}.number`} autoFocus={fields.get(index).isNew} />
            <Field component={SelectInput} name={`${name}.type`} elementClasses="type-select" options={convertArrayToOptions(PHONE_TYPES)} />
            <span><RemoveButton onClick={() => fields.remove(index)} className="margin-left" /></span>
          </Row>
        ) }
        <a href="" onClick={preventDefault(() => fields.push({ isNew: true }))}>Add Phone Number</a>
      </div>
    </Subform>
  );
}

RenderNumbers.propTypes = {
  fields: PropTypes.object,
  meta: PropTypes.object
};

// Component
export default function PhoneNumberForm(props) {
  return <FieldArray {...props} component={RenderNumbers} name="phoneNumbers" />;
}
